/**
 * Checks if a field is a country field
 * @param {string} label 
 * @returns {boolean}
 */
export const isCountryField = (label) => {
  return (
    label.toLowerCase().trim() === 'country' || 
    label.toLowerCase().trim() === 'countries'
  )
};

/**
 * Checks if a field is a state field
 * @param {string} label 
 * @returns {boolean}
 */
export const isStateField = (label) => {
  return (
    label.toLowerCase().trim() === 'state' || 
    label.toLowerCase().trim() === 'states'
  )
};

export const isSubField = (parent) => {
  return (
    parent?.toLowerCase().trim().includes("organization") ||
    parent?.toLowerCase().trim().includes("address") ||
    parent?.toLowerCase().trim().includes("contact") ||
    false
  )
}